import React from "react";
import "./tables.css";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useTheme } from "@mui/material/styles";

// Per-cell Diff indicator. Always renders — grey when this env's record
// matches the target env, orange when one or more fields differ.
//
// This is intentionally just the icon: clicking it hands its cell/diff
// info off to the single, page-level SyncDialog (see confirmMatchDialog.js)
// via handleMatchClickOpen rather than opening its own <Modal>. Every row
// in the table renders one of these per env column, so if each also
// carried its own Modal, a table with N rows would mount up to 2N
// simultaneously-"open" dialogs the moment any one was clicked — unreliable
// for click handling in a real browser. One shared dialog avoids that.
const DiffIndicatorIcon = ({ cell, isDifferent, diffFields, targetRow, handleMatchClickOpen }) => {
  const theme = useTheme();
  const targetEnv = cell.column.id;
  const iconColor = isDifferent ? theme.palette.warning.main : theme.palette.action.disabled;
  const tooltip = isDifferent
    ? `Differs from ${targetEnv}: ${diffFields.join(", ")}`
    : `No differences from ${targetEnv}`;

  return (
    <IconButton
      size="small"
      sx={{ color: iconColor, ml: 0.5, "&:hover": { bgcolor: "action.hover" } }}
      onClick={() => handleMatchClickOpen({ cell, diffFields, targetRow })}
    >
      <Tooltip id="button-report" title={tooltip}>
        <CompareArrowsIcon fontSize="small" sx={{ color: iconColor }} />
      </Tooltip>
    </IconButton>
  );
};

export default DiffIndicatorIcon;
